import React, { useEffect, useState } from 'react';
import { Spinner, Avatar } from "@chakra-ui/react";
import { useParams } from 'react-router-dom';
import { getAnchorInfo } from '../services/Wallet/partnerInfoService';
import { useWallet } from 'contexts/WalletContext';

const getRandomColor = () => {
    const colors = ["red.400", "blue.400", "green.400", "teal.400", "purple.400", "orange.400"];
    return colors[Math.floor(Math.random() * colors.length)];
};

const InfoRow = ({ label, value }) => (
    <div className="mb-2">
        <p className="text-sm text-gray-600">{label}</p>
        <p className="font-semibold text-base">{value ?? "N/A"}</p>
    </div>
);

const capitalizeFirst = s =>
    typeof s === 'string' && s.length
      ? s.charAt(0).toUpperCase() + s.slice(1)
      : s;

const PartnerInfoCard = () => {
    const { id } = useParams();
    const [partnerInfo, setPartnerInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const { setWallet } = useWallet();

    useEffect(() => {
        const fetchPartnerInfo = async () => {
            try {
                const data = await getAnchorInfo(id);
                setPartnerInfo(data);
                
                if (data?.wallet_id) {
                    setWallet(prev => ({
                        ...prev,
                        anchorWalletId: data.wallet_id,
                    }));
                }
            } catch (err) {
                console.error("Failed to load partner info", err);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchPartnerInfo();
        }
    }, [id, setWallet]);

    if (loading) {
        return <Spinner size="lg" thickness="4px" color="blue.500" />;
    }

    if (!partnerInfo) {
        return <div className="text-red-600">Failed to load partner information.</div>;
    }

    return (
        <>
            <div className="bg-[#F3F4F6] rounded-md mx-4 my-4 p-4 flex flex-col md:flex-row items-start md:items-center justify-evenly gap-6">
                <div className="flex-shrink-0">
                    <Avatar
                        name={partnerInfo.name}
                        boxSize="70px"
                        bg={getRandomColor()}
                        color="white"
                        fontWeight="bold"
                    />
                </div>

                <div className="flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
                    <InfoRow label="Name" value={capitalizeFirst(partnerInfo?.name)} />
                    <InfoRow label="Code" value={partnerInfo?.code} />
                    <InfoRow label="Address" value={capitalizeFirst(partnerInfo?.address)} />
                    <InfoRow label="Point of Contact" value={capitalizeFirst(partnerInfo?.poc)} />
                    <InfoRow label="Contact No." value={partnerInfo.contact_no} />
                    <InfoRow label="Email" value={partnerInfo.email} />
                </div>
            </div>
        </>
    );
};

export default PartnerInfoCard;
